
import React, { useEffect } from 'react';
import { useAuth } from '@/contexts/MyContext';
import { useUpsellLightbox } from '@/hooks/use-upsell-lightbox';
import UnlimitedDevLightbox from './UnlimitedDevLightbox';
import EliteVIPLightbox from './EliteVIPLightbox';
import { getMembership } from '@/data/memberships';
import { useNavigate, useLocation } from 'react-router-dom';

const UpsellLightboxManager: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = !!user;
  const isAdmin = user?.isAdmin === true;
  
  // Check if user already owns the unlimited membership
  const userHasUnlimited = user?.memberships?.includes('unlimited') || false;
  
  // Check if user already owns the elite VIP membership
  const userHasEliteVIP = user?.memberships?.includes('elite-vip') || false;
  
  const {
    showUnlimitedLightbox,
    showEliteVIPLightbox,
    closeUnlimitedLightbox,
    closeEliteVIPLightbox
  } = useUpsellLightbox({ 
    isLoggedIn,
    isAdmin,
    userHasUnlimited,
    userHasEliteVIP
  });

  // Handle redirection when user navigates back from payment page
  useEffect(() => {
    // If user is logged in and at root path or login page (which may happen after going back from payment)
    if (isLoggedIn && (location.pathname === '/' || location.pathname === '/login')) {
      // Redirect to dashboard instead of staying at login or home page
      navigate('/dashboard', { replace: true });
    }
  }, [isLoggedIn, location.pathname, navigate]);

  // Get the membership details to ensure links are accurate
  const unlimitedMembership = getMembership('unlimited');
  const eliteVIPMembership = getMembership('elite-vip');
  
  return (
    <>
      {showUnlimitedLightbox && 
        <UnlimitedDevLightbox 
          open={showUnlimitedLightbox} 
          onClose={closeUnlimitedLightbox} 
          paymentLink={unlimitedMembership?.paymentLink}
        />
      }
      
      {showEliteVIPLightbox && !userHasEliteVIP && 
        <EliteVIPLightbox 
          open={showEliteVIPLightbox} 
          onClose={closeEliteVIPLightbox}
          paymentLink={eliteVIPMembership?.paymentLink} 
        />
      }
    </>
  );
};

export default UpsellLightboxManager;
